import controllerDataConfigApi from '@/api/config/controllerDataConfig'
import { queryKeys } from '@/constant/common'
import { parseDecoderUsage } from '@/features/config/pages/Controllers/decoderUsage'
import { DecoderUsageResult } from '@/types/controller'
import { useQuery } from '@tanstack/react-query'

export const decoderUsageKey = (interfaceId: number, id?: string) => [
  queryKeys.controller,
  'usage',
  interfaceId,
  id,
]

const useDecoderUsage = (interfaceId: number, id?: string, enabled = true) =>
  useQuery<DecoderUsageResult>(
    decoderUsageKey(interfaceId, id),
    async () => {
      const { data } = await controllerDataConfigApi.getUsage(interfaceId, String(id))
      const usage = parseDecoderUsage(data)
      if (!usage) throw new Error('Unexpected decoder usage response')
      return usage
    },
    {
      enabled: enabled && interfaceId > 0 && !!id,
      staleTime: 0,
      cacheTime: 0,
    },
  )

export default useDecoderUsage
